import { useAppSelector } from "../../../redux/hooks/hooks";
import { selectElaborationStatusList } from "../../../redux/feature/object/remote-elaborations-slice";
import { useEffect, useMemo } from "react";
import { DOWNLOAD_COPY } from "../../../utils/constants/navigation";
import LoadingManager from "../../../common/loading/LoadingManager";

export function useHandleLoaderForDownloadCopy(): void {
  const elaborations = useAppSelector(selectElaborationStatusList);

  const downloadElab = useMemo(() => {
    if (!elaborations) return [];
    const elaborationItems = elaborations.flatMap((e) => e.items);
    return elaborationItems.filter(
      (item) => item.elaborationType === DOWNLOAD_COPY && (item.status === "REQUESTED" || item.status === "STARTED")
    );
  }, [elaborations]);

  useEffect(() => {
    if (downloadElab.length) LoadingManager.create(DOWNLOAD_COPY);
    else LoadingManager.remove(DOWNLOAD_COPY);
  }, [downloadElab]);
}
